
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { resourceService } from '@/projects/admin/services/resource-service';
import { t } from 'i18next';
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const ResourceList = () => {
    const [store, setStore] = useState<CustomStore>();
    useEffect(() => {
        setStore(createCustomStore({
            key: ["id"],
            load: resourceService.getResources,
            byKey: (key, loadOptions) => {
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                }
            },
            remove: resourceService.deleteResource,
        }));
    }, [])

    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/admin/resource-definition/${id}`, { state: { id: id } })
    }
    const createFile = async () => {
        resourceService.createResourceFile().then(res => {

        });
    }
    const createResourceFileEditorOptions = useMemo(() => ({
        text: t('create_resource_file'),
        type: 'default',
        width: '250px',
        stylingMode: "contained", // Dolgun buton görünümü
        elementAttr: {
            class: "custom-toolbar-button", // Özel CSS için sınıf ekliyoruz
        },
        onClick: createFile
    }), []);

    return (
        <>
            <DataGridWrapper
              permissonCode='Admin.Resource.Resource'
                datasource={store}
                remoteOperations={false}
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                enableCustomToolbarContent={true}
                isAddNewBtn={true}
                navigateNewRecordPath='/admin/resource-definition'
                editingConfig={{
                    allowDeleting: true,
                    allowUpdating: true,
                    confirmDelete: true,
                    deleteMessageText: RemoveMessage('Resource'),
                }}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: function (e: any) {
                            goToEdit(e.row?.data.id)
                        },
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
                columns={[
                    {
                        dataField: 'applicationName',
                        caption: t('application')
                    },
                    {
                        dataField: 'code',
                        caption: t('code'),
                        allowFiltering: true,
                    },
                    {
                        dataField: 'description',
                        caption: t('name'),
                        allowFiltering: true,
                    }
                ]}
                customToolbarItems={[
                    {
                        widget: "dxButton",
                        location: "after",
                        options: createResourceFileEditorOptions
                    }
                ]}
            />
        </>
    )
}
export default ResourceList